import { create } from 'zustand';
import { Network } from '@capacitor/network';

/**
 * Online/offline state. Drives the global offline banner and lets
 * mutations short-circuit before they hit the network.
 */
interface NetworkState {
  online: boolean;
  connectionType: string;
  setStatus: (online: boolean, connectionType?: string) => void;
  startListening: () => Promise<void>;
}

export const useNetworkStore = create<NetworkState>((set) => ({
  online: typeof navigator === 'undefined' ? true : navigator.onLine,
  connectionType: 'unknown',

  setStatus(online, connectionType = 'unknown') {
    set({ online, connectionType });
  },

  async startListening() {
    try {
      const status = await Network.getStatus();
      set({ online: status.connected, connectionType: status.connectionType });
      Network.addListener('networkStatusChange', (status) => {
        set({ online: status.connected, connectionType: status.connectionType });
      });
    } catch (error) {
      console.warn('[network] Capacitor Network unavailable, falling back to navigator events:', error);
      if (typeof window !== 'undefined') {
        window.addEventListener('online', () => set({ online: true }));
        window.addEventListener('offline', () => set({ online: false }));
      }
    }
  },
}));
